/* SALWAR MAHAL sticky Add to Cart (mobile bottom bar + desktop floating card).
   It never adds to cart by itself: size chips click the page's own size buttons and
   the Add to Cart button clicks the page's own Add to Cart, so price, stock, low-stock
   tags, cart drawer and tracking all keep working exactly as on the main button. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/></svg>';
  var isUAE = window.SM_COUNTRY === 'AE';
  var bar, chipsEl, selectEl, selectVal, sheet, sheetChips, priceEl, btn, btnLabel, btnPrice, hideBar = true, queued = false;
  var desktop = window.matchMedia('(min-width: 750px)');

  function q(sel, root) { return (root || document).querySelector(sel); }
  function mainButton() { return q('[id^="ProductSubmitButton-"]'); }
  function mainButtonsWrap() { var b = mainButton(); return b ? b.closest('.product-form__buttons') || b : null; }

  function sizeFieldset() {
    var sets = document.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < sets.length; i++) {
      var legend = q('legend', sets[i]);
      if (legend && /size/i.test(legend.textContent)) return sets[i];
    }
    return null;
  }

  // the bar is small, so "Unstitched Material Only" is shortened to "Unstitched" here
  // (the size buttons on the page itself keep the full wording)
  function shortLabel(text) { return text.trim().replace(/^unstitched( material)?( only)?$/i, 'Unstitched'); }

  function build() {
    var title = q('.product__title h1, .product__title h2, h1');
    var img = q('.product__media img, .product-media-container img');
    bar = document.createElement('div');
    bar.className = 'sm-sticky' + (isUAE ? ' sm-sticky--cod' : '');
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="sm-sticky__inner">' +
        '<div class="sm-sticky__product">' +
          (img ? '<img class="sm-sticky__thumb" alt="" src="' + (img.currentSrc || img.src) + '">' : '') +
          '<div class="sm-sticky__meta">' +
            '<div class="sm-sticky__title">' + (title ? title.textContent.trim().replace(/</g, '&lt;') : '') + '</div>' +
            '<div class="sm-sticky__price"></div>' +
          '</div>' +
        '</div>' +
        '<div class="sm-sticky__sizes" role="group" aria-label="Size"></div>' +
        '<button type="button" class="sm-sticky__select" aria-haspopup="true" aria-expanded="false"><span class="sm-sticky__select-cap">Size</span><span class="sm-sticky__select-val"></span></button>' +
        '<div class="sm-sticky__buy">' +
          '<button type="button" class="sm-sticky__btn"><span class="sm-sticky__label">Add to cart</span><span class="sm-sticky__btnprice"></span></button>' +
          (isUAE ? '<div class="sm-sticky__cod">' + ICON + '<span>Free Cash on Delivery in UAE</span></div>' : '') +
        '</div>' +
      '</div>' +
      '<div class="sm-sticky__sheet" hidden>' +
        '<div class="sm-sticky__sheet-title">Select size</div>' +
        '<div class="sm-sticky__sheet-chips" role="group" aria-label="Size"></div>' +
      '</div>';
    document.body.appendChild(bar);
    chipsEl = q('.sm-sticky__sizes', bar);
    selectEl = q('.sm-sticky__select', bar);
    selectVal = q('.sm-sticky__select-val', bar);
    sheet = q('.sm-sticky__sheet', bar);
    sheetChips = q('.sm-sticky__sheet-chips', bar);
    btnPrice = q('.sm-sticky__btnprice', bar);
    priceEl = q('.sm-sticky__price', bar);
    btn = q('.sm-sticky__btn', bar);
    btnLabel = q('.sm-sticky__label', bar);
    function addToCart() {
      var main = mainButton();
      if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true') return;
      main.click();
      schedule();
    }
    btn.addEventListener('click', addToCart);
    // the Free COD strip under the button adds to cart too (people tap it)
    var cod = q('.sm-sticky__cod', bar);
    if (cod) cod.addEventListener('click', addToCart);
  }

  function render() {
    queued = false;
    if (!bar) return;
    // price: the main product price block (Dawn re-renders it on size change)
    var price = q('.product__info-container .price, .product__info-wrapper .price');
    if (price) {
      var sale = price.classList.contains('price--on-sale');
      var now = q(sale ? '.price__sale .price-item--last' : '.price__regular .price-item--regular', price);
      var was = sale ? q('.price__sale s.price-item--regular', price) : null;
      // always "AED ~~259~~ 229" / "AED 229", whatever format the theme printed
      var nowNum = now ? now.textContent.replace(/[^0-9.,]/g, '') : '';
      var wasNum = was ? was.textContent.replace(/[^0-9.,]/g, '') : '';
      var priceHtml = 'AED ' + (wasNum ? '<s>' + wasNum + '</s> ' : '') + nowNum;
      if (priceEl.innerHTML !== priceHtml) priceEl.innerHTML = priceHtml;
      var btnHtml = priceHtml;
      if (btnPrice.innerHTML !== btnHtml) btnPrice.innerHTML = btnHtml;
    }
    // size chips mirror the page's own size buttons
    var fs = sizeFieldset();
    var html = '', picked = '', count = 0;
    if (fs) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = q('label[for="' + input.id + '"]', fs);
        var text = label ? (label.childNodes[0] ? label.childNodes[0].textContent : label.textContent) : input.value;
        var off = input.classList.contains('disabled');
        count++;
        if (input.checked) picked = shortLabel(text);
        html += '<button type="button" class="sm-chip' + (input.checked ? ' is-on' : '') + (off ? ' is-off' : '') + '" data-for="' + input.id + '" aria-pressed="' + (input.checked ? 'true' : 'false') + '"' + (off ? ' aria-label="' + input.value.replace(/"/g, '&quot;') + ' sold out"' : '') + '>' + shortLabel(text).replace(/</g, '&lt;') + '</button>';
      });
    }
    bar.classList.toggle('sm-sticky--onesize', count === 1); // shown, but nothing to choose
    if (chipsEl.innerHTML !== html) chipsEl.innerHTML = html;
    if (sheetChips.innerHTML !== html) sheetChips.innerHTML = html;
    if (selectVal.textContent !== picked) selectVal.textContent = picked;
    selectVal.classList.toggle('is-long', picked.length > 11);
    bar.classList.toggle('sm-sticky--nosize', !html);
    // button state follows the main button
    var main = mainButton();
    var loading = main && main.classList.contains('loading');
    var soldOut = !main || (main.disabled && /sold|unavailable/i.test(main.textContent));
    btn.disabled = soldOut;
    btn.classList.toggle('is-loading', !!loading);
    btnLabel.textContent = loading ? 'Adding…' : (soldOut ? 'Sold out' : 'Add to cart');
  }

  // After a size change Dawn re-focuses the size button (product-info.js) and scrolls up to
  // the size's photo (media-gallery.js). From the sticky bar both would yank the shopper
  // away, so for a moment focus without scrolling and skip page-level scroll jumps.
  var nativeScrollTo = window.scrollTo, nativeFocus = HTMLElement.prototype.focus, holdTimer;
  function holdScroll(ms) {
    var until = Date.now() + ms;
    window.scrollTo = function (a) {
      if (Date.now() < until && a && typeof a === 'object' && 'top' in a) return;
      return nativeScrollTo.apply(window, arguments);
    };
    HTMLElement.prototype.focus = function (opts) {
      return nativeFocus.call(this, Object.assign({}, opts, { preventScroll: true }));
    };
    clearTimeout(holdTimer);
    holdTimer = setTimeout(function () {
      window.scrollTo = nativeScrollTo;
      HTMLElement.prototype.focus = nativeFocus;
    }, ms);
  }

  function schedule() { if (!queued) { queued = true; setTimeout(render, 60); } }

  function setVisible() {
    var show = !hideBar;
    bar.classList.toggle('is-shown', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('sm-sticky-on', show);
    document.documentElement.style.setProperty('--sm-sticky-h', bar.offsetHeight + 'px');
    placeUnderHeader();
    window.dispatchEvent(new Event('sm:sticky')); // lets the pinned desktop gallery move below the bar
  }

  // the bar sits at the bottom on every screen size now (desktop = floating card)
  function placeUnderHeader() { bar.style.top = ''; }

  function watchMainButton() {
    var target = mainButtonsWrap();
    if (!target || !('IntersectionObserver' in window)) { hideBar = false; setVisible(); return; }
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // mobile: show whenever the main button is off screen;
      // desktop: only once the shopper has scrolled past it (not while it's still below)
      hideBar = e.isIntersecting || (desktop.matches && e.boundingClientRect.top > 0);
      setVisible();
    });
    io.observe(target);
    // Dawn can replace the buttons on variant change; re-attach when that happens
    watchMainButton.io && watchMainButton.io.disconnect();
    watchMainButton.io = io;
    watchMainButton.el = target;
  }

  function init() {
    if (!mainButton()) return;
    build();
    render();
    watchMainButton();
    // change the page's own size without focusing it (focusing would scroll the page up)
    function pick(id) {
      var input = document.getElementById(id);
      if (!input || input.checked) return;
      holdScroll(2500);
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      schedule();
    }
    chipsEl.addEventListener('click', function (e) {
      var chip = e.target.closest('.sm-chip');
      if (chip) pick(chip.getAttribute('data-for'));
    });
    // mobile: the size box opens a small panel of size buttons right above the bar
    function openSheet(open) {
      sheet.hidden = !open;
      selectEl.setAttribute('aria-expanded', open ? 'true' : 'false');
      bar.classList.toggle('sheet-open', open);
      document.body.classList.toggle('sm-sheet-open', open);
    }
    selectEl.addEventListener('click', function () {
      if (bar.classList.contains('sm-sticky--onesize')) return;
      openSheet(sheet.hidden);
    });
    sheetChips.addEventListener('click', function (e) {
      var chip = e.target.closest('.sm-chip');
      if (!chip || chip.classList.contains('is-off')) return;
      pick(chip.getAttribute('data-for'));
      setTimeout(function () { openSheet(false); }, 120);
    });
    document.addEventListener('click', function (e) { if (!sheet.hidden && !bar.contains(e.target)) openSheet(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) openSheet(false); });
    window.addEventListener('scroll', function () { if (!sheet.hidden && !bar.classList.contains('is-shown')) openSheet(false); }, { passive: true });
    var root = q('product-info') || q('main') || document.body;
    new MutationObserver(function (records) {
      // ignore changes we make to the bar itself
      if (records.every(function (r) { return bar.contains(r.target); })) return;
      schedule();
      if (watchMainButton.el && !document.body.contains(watchMainButton.el)) watchMainButton();
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'disabled', 'class'] });
    root.addEventListener('change', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
